// Floating Contact Buttons Animation
document.addEventListener('DOMContentLoaded', function() {
  // Add animation to contact buttons
  function addPulseAnimation() {
    const contactButtons = document.querySelectorAll('.contact-button');
    
    contactButtons.forEach(button => {
      // Add pulse animation
      function pulse() {
        button.animate([
          { boxShadow: '0 0 0 0 rgba(0, 0, 0, 0.5)' },
          { boxShadow: '0 0 0 10px rgba(0, 0, 0, 0)' },
          { boxShadow: '0 0 0 0 rgba(0, 0, 0, 0)' }
        ], {
          duration: 2000,
          iterations: Infinity
        });
      }
      
      pulse();
      
      // Add hover effect
      button.addEventListener('mouseenter', function() {
        this.style.transform = 'scale(1.1)';
        this.style.boxShadow = '0 6px 15px rgba(0, 0, 0, 0.3)';
        
        // Show tooltip
        const tooltip = document.createElement('span');
        tooltip.textContent = this.getAttribute('data-tooltip');
        tooltip.style.position = 'absolute';
        tooltip.style.right = '70px';
        tooltip.style.backgroundColor = '#333';
        tooltip.style.color = 'white';
        tooltip.style.padding = '5px 10px';
        tooltip.style.borderRadius = '5px';
        tooltip.style.fontSize = '14px';
        tooltip.style.whiteSpace = 'nowrap';
        tooltip.className = 'contact-tooltip';
        
        this.appendChild(tooltip);
      });
      
      button.addEventListener('mouseleave', function() {
        this.style.transform = 'scale(1)';
        this.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.3)';
        
        // Remove tooltip
        const tooltip = this.querySelector('.contact-tooltip');
        if (tooltip) {
          this.removeChild(tooltip);
        }
      });
    });
  }
  
  // Call the function after a short delay to ensure elements are loaded
  setTimeout(addPulseAnimation, 1000);
});
